import { styled } from '@mui/material';
import { PageHeaderStatic } from '@procureai/ui-mui';

export const PageHeaderStaticStyled = styled(PageHeaderStatic)<{ hasTabs?: boolean }>(({ hasTabs }) => ({
  height: hasTabs ? 113 : undefined,
}));
